// extracted by mini-css-extract-plugin
export var bodyRow = "_dx-d";
export var cardColumns = "_dx-e";
export var ellipsesOverflow = "_dx-2";
export var flatBottomCorners = "_dx-3";
export var flatTopCorners = "_dx-4";
export var headerActionsDropdown = "_dx-f";
export var headerBottomRow = "_dx-c";
export var headerTopRow = "_dx-b";
export var orderDetailsWrapper = "_dx-0";
export var orderInfoContainer = "_dx-1";
export var productDetails = "_dx-9";
export var productImage = "_dx-5";
export var responsiveTable = "_dx-8";
export var shipmentContainer = "_dx-a";
export var tableBottomLeft = "_dx-6";
export var tableBottomRight = "_dx-7";
export var trackingLink = "_dx-g";